<loading-bar [label]="'Loading'" *ngIf="loading" />

<div class="details-section"  *ngIf="data">
  <button mat-raised-button color="primary" routerLink="/edit-technical-details/{{assetId}}">
    <mat-icon>edit</mat-icon>
    Edit
</button>

    <div class="section-header">Technical data</div>
    <div class="section-content">
    <div class="section-tab">
        <div class="row"><div class="col1">IP Class:</div><div class="col">{{ data.ipClass }}</div></div>
        <div class="row"><div class="col1">IC Class:</div><div class="col">{{ data.icClass }}</div></div>
        <div class="row"><div class="col1">IM Class:</div><div class="col">{{ data.imClass }}</div></div>
        <div class="row"><div class="col1">Insulation Class:</div><div class="col">{{ data.insulationClass }}</div></div>
        <div class="row"><div class="col1">Temperature Rise Class:</div><div class="col">{{ data.temperatureRiseClass }}</div></div>
        <div class="row"><div class="col1">Ambient temp [°C]:</div><div class="col">{{ data.ambientTemperature }}</div></div>
        <div class="row"><div class="col1">Installation altitude [m]:</div><div class="col">{{ data.altitude }}</div></div>
        <div class="row"><div class="col1">Poles High:</div><div class="col">{{ data.polesHigh }}</div></div>
        <div class="row"><div class="col1">Poles Low:</div><div class="col">{{ data.polesLow }}</div></div>
        <div class="row"><div class="col1">Type of duty:</div><div class="col">{{ data.typeOfDuty }}</div></div>
        <div class="row"><div class="col1">EX-Protection:</div><div class="col">{{ data.exProtection }}</div></div>
        <div class="row"><div class="col1">Gas Group:</div><div class="col">{{ data.gasGroup }}</div></div>
        <div class="row"><div class="col1">Temperature Class:</div><div class="col">{{ data.temperatureClass }}</div></div>
        <div class="row"><div class="col1">Certificate number:</div><div class="col">{{ data.certificateNumber }}</div></div>
        <div class="row"><div class="col1">Bearing DE:</div><div class="col">{{ data.bearing }}</div></div>
        <div class="row"><div class="col1">Bearing NDE:</div><div class="col">{{ data.nonBearing }}</div></div>
        <div class="row"><div class="col1">Net Weight:</div><div class="col">{{ data.netWeight }}</div></div>
        <div class="row"><div class="col1">Gross Weight:</div><div class="col">{{ data.grossWeight }}</div></div>
        <div class="row"><div class="col1">Atex Category:</div><div class="col">{{ data.atexCategory }}</div></div>
    </div> 
    </div>
</div>

<div class="details-section"  *ngIf="data">
    <div class="section-header">IE Classes</div>
    <div class="section-content">
    <div class="section-tab">
        <table mat-table [dataSource]="data.frequencyParameters" class="mat-elevation-z2">
            <ng-container matColumnDef="frequency">
                <th mat-header-cell *matHeaderCellDef matTooltip="Motor's frequency"> <b>Frequency</b> </th>
                <td mat-cell *matCellDef="let element"> {{element.frequency}} </td>
            </ng-container>

            <ng-container matColumnDef="ieClass">
                <th mat-header-cell *matHeaderCellDef matTooltip="IEC class for motor efficiency"> <b>IE
                        Class</b> </th>
                <td mat-cell *matCellDef="let element"> {{element.ieClass}} </td>
            </ng-container>

            <ng-container matColumnDef="load50">
                <th mat-header-cell *matHeaderCellDef matTooltip="Efficiency at 50%"> <b>50%</b> </th>
                <td mat-cell *matCellDef="let element"> {{element.loads[0].value}} </td>
            </ng-container>

            <ng-container matColumnDef="load75">
                <th mat-header-cell *matHeaderCellDef matTooltip="Efficiency at 50%"> <b>75% </b></th>
                <td mat-cell *matCellDef="let element"> {{element.loads[1].value}} </td>
            </ng-container>

            <ng-container matColumnDef="load100">
                <th mat-header-cell *matHeaderCellDef matTooltip="Efficiency at 50%"> <b>100%</b> </th>
                <td mat-cell *matCellDef="let element"> {{element.loads[2].value}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['frequency', 'ieClass', 'load50', 'load75', 'load100']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['frequency', 'ieClass', 'load50', 'load75', 'load100'];">
            </tr>
        </table>
    </div> 
    </div>
</div>


<div class="details-section"  *ngIf="data">
    <div class="section-header">Electrical data</div>
    <div class="section-content">
    <div class="section-tab">
        <mat-table [dataSource]="data.electricalData" class="mat-elevation-z2">
            <ng-container matColumnDef="printFlag">
              <mat-header-cell *matHeaderCellDef matTooltip="Flag for printing row of electrical data"> <b>Print Flag</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.printFlag}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="stampFlag">
              <mat-header-cell *matHeaderCellDef matTooltip="Flag indicating that row was stamped on motor nameplate"> <b>Stamp Flag</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.stampFlag}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="voltage">
              <mat-header-cell *matHeaderCellDef matTooltip="Operating voltage of the equipment"> <b>Voltage [V]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.voltage}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="frequency">
              <mat-header-cell *matHeaderCellDef matTooltip="Operating frequency of the equipment"> <b>Frequency [Hz]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.frequency}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="connection">
              <mat-header-cell *matHeaderCellDef matTooltip="Type of connection for the motor windings eg. Star, Delta"> <b>Connection</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.connection}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="powerOutput">
              <mat-header-cell *matHeaderCellDef matTooltip="Power output of the equipment"> <b>Power [kW]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.powerOutput}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="speed">
              <mat-header-cell *matHeaderCellDef matTooltip="Operating speed of the motor at the given conditions"> <b>Speed [r/min]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.speed}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="efficiency">
              <mat-header-cell *matHeaderCellDef matTooltip="Efficiency of the motor at the given conditions"> <b>Efficiency %</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.efficiency}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="powerFactor">
              <mat-header-cell *matHeaderCellDef matTooltip="Power factor at the given conditions"> <b>Power Factor</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.powerFactor}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="current">
              <mat-header-cell *matHeaderCellDef matTooltip="Current drawn by the equipment"> <b>Current [A]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.current}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="stallTime">
              <mat-header-cell *matHeaderCellDef matTooltip="Stall time"> <b>Stall Time</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.stallTime}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="torque">
              <mat-header-cell *matHeaderCellDef matTooltip="Torque output by the equipment"> <b>Torque [Nm]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.torque}} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="isIn">
              <mat-header-cell *matHeaderCellDef matTooltip="Ratio of starting to normal current"> <b>Is In</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.isIn}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="secondaryVoltage">
              <mat-header-cell *matHeaderCellDef matTooltip="Secondary voltage of the equipment"> <b>Secondary Voltage [V]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.secondaryVoltage}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="secondaryCurrent">
              <mat-header-cell *matHeaderCellDef matTooltip="Secondary current of the equipment"> <b>Secondary Current [A]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.secondaryCurrent}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="excitationVoltage">
              <mat-header-cell *matHeaderCellDef matTooltip="Excitation voltage of the equipment"> <b>Excitation Voltage [V]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.excitationVoltage}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="excitationCurrent">
              <mat-header-cell *matHeaderCellDef matTooltip="Excitation current of the equipment"> <b>Excitation Current [A]</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.excitationCurrent}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="connectionRotor">
              <mat-header-cell *matHeaderCellDef matTooltip="Type of connection for the rotor windings eg. Star, Delta"> <b>Connection Rotor</b> </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.connectionRotor}} </mat-cell>
            </ng-container>
          
            <mat-header-row *matHeaderRowDef="electricalDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: electricalDisplayedColumns;"></mat-row>
          </mat-table>
    </div> 
    </div>
</div>


<div class="details-section"  *ngIf="data">
    <div class="section-header">Variants</div>
    <div class="section-content">
    <div class="section-tab">
        <mat-table *ngIf="data.variants" [dataSource]="data.variants" class="mat-elevation-z1">
            <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef><b> Variant Code</b> </mat-header-cell>
                <mat-cell *matCellDef="let variant"> {{ variant.code }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef><b> Description</b> </mat-header-cell>
                <mat-cell *matCellDef="let variant"> {{ variant.description }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="instruction">
                <mat-header-cell *matHeaderCellDef><b> Instruction</b> </mat-header-cell>
                <mat-cell *matCellDef="let variant"> {{ variant.instruction }} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="variantDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: variantDisplayedColumns;"></mat-row>
        </mat-table>
    </div> 
    </div>
</div>



<!-- 

<div *ngIf="data" class="columns-2-rows-4-layout">
    <mat-card class="column1 row1">
        <mat-card-header>
            <mat-card-title>Technical data</mat-card-title>
        </mat-card-header>
        <mat-card-content class="card-content">
            <p matTooltip="Ingress protection class for the asset" matTooltipPosition="before"><b>IP Class:</b> {{ data.ipClass }}</p>
            <p matTooltip="Code indicating type of cooling employed" matTooltipPosition="before"><b>IC Class:</b> {{ data.icClass }}</p>
            <p matTooltip="Code indicating type of cooling employed" matTooltipPosition="before"><b>IM Class:</b> {{ data.imClass }}</p>
            <p matTooltip="Insulation Class of the Asset" matTooltipPosition="before"><b>Insulation Class:</b> {{ data.insulationClass }}</p>
            <p matTooltip="Code indicating allowable increase in temperature under operating condition" matTooltipPosition="before">
                <b>Temperature Rise Class:</b>
                {{ data.temperatureRiseClass }}
            </p>
            <p 
                matTooltip="Ambient temperature range for the installation. Values - Low (0 C- 25 C), Medium (0 C- 40 C), High (Below 0 C and above 40 C)"
                matTooltipPosition="before">
                <b>Ambient temp [°C]:</b>
                {{ data.ambientTemperature }}
            </p>
            <p matTooltip="Altitude at which the Asset has been installed" matTooltipPosition="before"><b>Installation altitude [m]:</b> {{ data.altitude }} </p>
            <p matTooltip="Number of poles (high) of the motor" matTooltipPosition="before"><b>Poles High:</b> {{ data.polesHigh }}</p>
            <p matTooltip="Number of poles (low) of the motor" matTooltipPosition="before"><b>Poles Low:</b> {{ data.polesLow }}</p>
            <p matTooltip="Duty class of the motor" matTooltipPosition="before"><b>Type of duty:</b> {{ data.typeOfDuty }}</p>
            <p matTooltip="Explosion protection details of the Asset" matTooltipPosition="before"><b>EX-Protection:</b>{{ data.exProtection }} </p>
            <p matTooltip="Gas group for the area where the asset is installed" matTooltipPosition="before"><b>Gas Group:</b> {{ data.gasGroup }}
            </p>
            <p matTooltip="Temperature class of the area in which the asset is installed" matTooltipPosition="before"><b>Temperature Class:</b> {{
                data.temperatureClass }}</p>
            <p matTooltip="Certificate details for the asset" matTooltipPosition="before"><b>Certificate number:</b> {{ data.certificateNumber }}
            </p>
            <p matTooltip="Bearing type - Driving end of the motor" matTooltipPosition="before"><b>Bearing DE:</b> {{ data.bearing }}</p>
            <p matTooltip="Bearing type - Non Driving end of the motor" matTooltipPosition="before"><b>Bearing NDE:</b> {{ data.nonBearing }}</p>
            <p matTooltip="Net weight of the asset" matTooltipPosition="before"><b>Net Weight:</b> {{ data.netWeight }}</p>
            <p matTooltip="Gross weight of the asset" matTooltipPosition="before"><b>Gross Weight:</b> {{ data.grossWeight }}</p>
        </mat-card-content>
    </mat-card>

    <div class="row1 column2">
        <mat-card>
            <mat-card-header>
                <mat-card-title>IE Classes</mat-card-title>
            </mat-card-header>
            <mat-card-content class="card-content">
                <table mat-table [dataSource]="data.frequencyParameters" class="mat-elevation-z2">
                    <ng-container matColumnDef="frequency">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Motor's frequency"> <b>Frequency</b> </th>
                        <td mat-cell *matCellDef="let element"> {{element.frequency}} </td>
                    </ng-container>

                    <ng-container matColumnDef="ieClass">
                        <th mat-header-cell *matHeaderCellDef matTooltip="IEC class for motor efficiency"> <b>IE
                                Class</b> </th>
                        <td mat-cell *matCellDef="let element"> {{element.ieClass}} </td>
                    </ng-container>

                    <ng-container matColumnDef="load50">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Efficiency at 50%"> <b>50%</b> </th>
                        <td mat-cell *matCellDef="let element"> {{element.loads[0].value}} </td>
                    </ng-container>

                    <ng-container matColumnDef="load75">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Efficiency at 50%"> <b>75% </b></th>
                        <td mat-cell *matCellDef="let element"> {{element.loads[1].value}} </td>
                    </ng-container>

                    <ng-container matColumnDef="load100">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Efficiency at 50%"> <b>100%</b> </th>
                        <td mat-cell *matCellDef="let element"> {{element.loads[2].value}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['frequency', 'ieClass', 'load50', 'load75', 'load100']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['frequency', 'ieClass', 'load50', 'load75', 'load100'];">
                    </tr>
                </table>
            </mat-card-content>
        </mat-card>
    </div>

    <mat-card class="row2 all-columns">
        <mat-card-header>
            <mat-card-title>Electrical Data</mat-card-title>
        </mat-card-header>
        <mat-card-content class="card-content">
            <mat-table [dataSource]="data.electricalData" class="mat-elevation-z2">
                <ng-container matColumnDef="printFlag">
                  <mat-header-cell *matHeaderCellDef matTooltip="Flag for printing row of electrical data"> <b>Print Flag</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.printFlag}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="stampFlag">
                  <mat-header-cell *matHeaderCellDef matTooltip="Flag indicating that row was stamped on motor nameplate"> <b>Stamp Flag</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.stampFlag}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="voltage">
                  <mat-header-cell *matHeaderCellDef matTooltip="Operating voltage of the equipment"> <b>Voltage [V]</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.voltage}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="frequency">
                  <mat-header-cell *matHeaderCellDef matTooltip="Operating frequency of the equipment"> <b>Frequency [Hz]</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.frequency}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="connection">
                  <mat-header-cell *matHeaderCellDef matTooltip="Type of connection for the motor windings eg. Star, Delta"> <b>Connection</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.connection}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="powerOutput">
                  <mat-header-cell *matHeaderCellDef matTooltip="Power output of the equipment"> <b>Power [kW]</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.powerOutput}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="speed">
                  <mat-header-cell *matHeaderCellDef matTooltip="Operating speed of the motor at the given conditions"> <b>Speed [r/min]</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.speed}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="efficiency">
                  <mat-header-cell *matHeaderCellDef matTooltip="Efficiency of the motor at the given conditions"> <b>Efficiency %</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.efficiency}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="powerFactor">
                  <mat-header-cell *matHeaderCellDef matTooltip="Power factor at the given conditions"> <b>Power Factor</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.powerFactor}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="current">
                  <mat-header-cell *matHeaderCellDef matTooltip="Current drawn by the equipment"> <b>Current [A]</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.current}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="stallTime">
                  <mat-header-cell *matHeaderCellDef matTooltip="Stall time"> <b>Stall Time</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.stallTime}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="torque">
                  <mat-header-cell *matHeaderCellDef matTooltip="Torque output by the equipment"> <b>Torque [Nm]</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.torque}} </mat-cell>
                </ng-container>
              
                <ng-container matColumnDef="isIn">
                  <mat-header-cell *matHeaderCellDef matTooltip="Ratio of starting to normal current"> <b>Is In</b> </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.isIn}} </mat-cell>
                </ng-container>
              
                <mat-header-row *matHeaderRowDef="electricalDisplayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: electricalDisplayedColumns;"></mat-row>
              </mat-table>
        </mat-card-content>
    </mat-card>

    <mat-card class="row3 all-columns">
        <mat-card-header>
            <mat-card-title>Variants</mat-card-title>
        </mat-card-header>
        <mat-card-content class="card-content">
            <mat-table *ngIf="data.variants" [dataSource]="data.variants" class="mat-elevation-z1">
                <ng-container matColumnDef="code">
                    <mat-header-cell *matHeaderCellDef><b> Variant Code</b> </mat-header-cell>
                    <mat-cell *matCellDef="let variant"> {{ variant.code }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="description">
                    <mat-header-cell *matHeaderCellDef><b> Description</b> </mat-header-cell>
                    <mat-cell *matCellDef="let variant"> {{ variant.description }} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="instruction">
                    <mat-header-cell *matHeaderCellDef><b> Instruction</b> </mat-header-cell>
                    <mat-cell *matCellDef="let variant"> {{ variant.instruction }} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="variantDisplayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: variantDisplayedColumns;"></mat-row>
            </mat-table>

            <h3 *ngIf="!data.variants">No variants data for this asset</h3>
        </mat-card-content>
    </mat-card>
</div> -->

<div *ngIf="!loading && !data">
    <h3>Cannot load technical details</h3>
</div> 